import * as realReact from "react";

declare namespace Context {
  export function createContext<T>(
    defaultValue: T,
    calculateChangedBits?: (prev: T, next: T) => number
  ): Context<T>;

  type RenderFn<T> = (value: T) => realReact.ReactNode;

  export type Context<T> = {
    Provider: realReact.ComponentClass<ProviderProps<T>>;
    Consumer: realReact.ComponentClass<ConsumerProps<T>>;
  };

  export type ProviderProps<T> = {
    value: T;
    children: React.ReactNode;
  };

  export type ConsumerProps<T> = {
    children: RenderFn<T> | [RenderFn<T>];
    observedBits?: number;
  };
}

// tslint:disable-next-line:no-bitwise
// tslint:disable-next-line:no-any
export const React: typeof Context & typeof realReact = realReact as any;



// WEBPACK FOOTER //
// ./src/components/AuthProvider/react-with-context.ts